import {
  type AIConnector,
  isManagedMcpConnectorId,
} from "@p0security/shared/types/ai-inventory";

/**
 * Identifier strings that could carry the managed-gateway token for a given
 * Copilot Studio connector: whichever of its raw fields might hold the Power
 * Platform-style url-encoded connector id.
 */
const connectorIdCandidates = (
  connector: Extract<AIConnector, { platform: "copilot-studio" }>
): readonly (string | null | undefined)[] => [
  connector.data.connectorid,
  connector.data.connectionreferenceid,
];

/**
 * Whether a connector routes through the P0 MCP gateway ("managed" = traffic
 * is brokered + policy-enforced by P0). Distinct from "enrolled" (has an
 * assigned owner). Copilot Studio checks any id-like field for the
 * `p0-20[...]-20mcp-20server` marker; local-agents connectors carry a
 * precomputed `managed` flag (server id found in the P0 MCP registry).
 */
export const isConnectorManaged = (connector: AIConnector): boolean => {
  switch (connector.platform) {
    case "copilot-studio":
      return connectorIdCandidates(connector).some((id) =>
        isManagedMcpConnectorId(id)
      );
    case "local-agents":
      return connector.data.managed;
  }
};
